var _use, _symbol;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 63.75 85",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 1.875,
    y: 2.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 15H0l5 57.5L30 80l25-7.5L60 15",
    fill: "#1572b6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.739 52.5l.435-5 .652-7.5.652-7.5.652-7.5.435-5H30v55l15.179-4.554 5.134-1.54.67-7.701.67-7.701z",
    fill: "#33a9dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0h-9v11h9V8h-6V3h6zm13 0v3h-5l5 5v3H25V8h5l-5-5V0zm13 0v3h-5l5 5v3H38V8h5l-5-5V0z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.933 65.98l-2.567-.77-8.214-2.464-.67-7.701-.221-2.545h8l.436 5.009 2.567.77L30 60v7.5zM11.522 32.5h8 2.5H30V25h-8.63-2.5-8z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 60l8.304-2.491.435-5.009.435-5H30V40h9.826l.652-7.5H30V25h11.13 8l-.652 7.5-.652 7.5-.652 7.5-.435 5-.221 2.545-.67 7.701-8.214 2.464L30 67.5V60z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47.5h-6.674l-.652-7.5H30z",
    fill: "#ebebeb"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.3f56ea17468bc4cbc4ef8a57ef4bcef1.svg";
export { ForwardRef as ReactComponent };